import { ResumeHotel } from 'src/types'

import {
  HotelFilters,
  HotelSearchPeriods,
  HotelSelectionFilters
} from 'src/core/store/ducks/hotels/types'

type Value = {
  error: string
  filters: HotelFilters
  list: ResumeHotel[]
  loading: boolean
  message_id: string[]
  selectionFilters: HotelSelectionFilters
}

function ReducerOfSelectedHotelFilters(
  accSearches: HotelSearchPeriods,
  [key, value]: [string, Value]
): HotelSearchPeriods {
  const list = value.list
    .filter(item => {
      if (value.selectionFilters.name) {
        return item.brand_name
          .toLocaleUpperCase()
          .includes(value.selectionFilters.name)
      }
      return true
    })
    .filter(item => {
      if (value.selectionFilters.quarter.find(find => find.checked)) {
        return value.selectionFilters.quarter.find(
          find => find.title === item.quarter
        )?.checked
      }

      return true
    })

  return {
    ...accSearches,
    [key]: {
      ...value,
      list
    }
  }
}

export default ReducerOfSelectedHotelFilters
